import { StyleSheet } from 'react-native';

import { elGray } from 'app/src/styles/colors';

// The accounting reports page still renders every card in a wrapped grid,
// so it keeps the pre-report-picker layout styles locally instead of
// sharing the main Reports page's single-column styles.
export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    marginTop: 20,
    backgroundColor: elGray,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
  },
});

export const cardStyles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 10,
    minWidth: 600,
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  note: {
    color: 'red',
    fontWeight: 800,
    marginBottom: 10,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
  },
  select: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 5,
    marginBottom: 10,
    paddingHorizontal: 5,
    height: 25,
  },
});
